import { DateTime } from 'luxon';
import { type } from '@mews-framework/utils';
import { ISOFormat } from '../enums';

interface Time {
    value: string;
}

function Time(luxon: DateTime): Time {
    return type.create(Time, {
        value: luxon.toFormat(ISOFormat.TimeMilliseconds),
    });
}

export default Time;
